import { EsetSharedModule } from '@eset/eset-shared';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { reducers, metaReducers } from './reducers';
import { environment } from '@environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from '@shared/shared.module';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LoginModule } from '@features/login/login.module';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ReactiveFormsModule } from '@angular/forms';
import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from '@shared/services/app-title.strategy';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    EsetSharedModule,
    BrowserModule,
    AppRoutingModule,
    EffectsModule.forRoot([]),
    SharedModule,
    LoginModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    StoreRouterConnectingModule.forRoot(),
    IonicModule.forRoot({ useSetInputAPI: true }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    ReactiveFormsModule,
  ],
  providers: [provideHttpClient(withFetch()), { provide: TitleStrategy, useClass: AppTitleStrategy }],
})
export class AppModule {}
